import { React, useEffect, useState, useRef } from 'react';
import { Link as RouterLink, useNavigate, useLocation, useOutletContext } from 'react-router-dom';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { alpha, styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
    FormGroup,
    FormControlLabel,
    Checkbox,
    ListItemText,
    Grid,
    Typography, CardContent,
    Link,
    Box,
    Tabs,
    Tab,
    Badge,
    FormLabel,
    Modal,
    Chip,
    TextareaAutosize,
    Menu,
    ListItemIcon,

} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { startOfMonth, endOfMonth } from 'date-fns';
import { useSnackbar } from 'notistack';
import Moment from 'moment';
import { Icon } from '@iconify/react';
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SubdirectoryArrowRightOutlinedIcon from "@mui/icons-material/SubdirectoryArrowRightOutlined";
import AddIcon from '@mui/icons-material/Add';
import TreeView from '../../Common/TreeView';
import AppCache from '../../../services/AppCache';
import Iconify from '../../Iconify';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import Page from '../../Page';
import { handleError } from '../../Common/Utils';
import Blog from '../../../pages/Blog'
import ServiceCards from '../../Common/ServiceCard'

// ----------------------------------------------------------------------



// ----------------------------------------------------------------------
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: '92%',
    overflow: 'auto',   // 👈 you had auto, now hidden if you want
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
};
const childModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: '90%',
    overflow: 'auto',   // 👈 you had auto, now hidden if you want
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
};
const hierarchyStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '55%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: '90%',
    overflow: 'auto',   // 👈 you had auto, now hidden if you want
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
};
// lives only while the tab stays open
const tmpCache = {};
const stripHtml = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
};
export default function IssueListingPage() {
    const location = useLocation();

    const { onOpenSidebar, open, onCloseSidebar } = useOutletContext();

    const handleFilterClick = () => {
        onOpenSidebar(); // expand sidebar if collapsed
    };
    const handleFilterCollapseClick = () => {
        onCloseSidebar();
    };
    const StatusDropdown = [
        { Id: 0, value: 'Pending' },
        { Id: 1, value: 'Closed' },
        { Id: 2, value: 'All' },
        { Id: 3, value: 'Routine' },
    ];

    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

    const [issueData, setIssueData] = useState([]);
    const [pageSize, setPageSize] = useState(25);

    const userId = CurrentLoggedInUser?.ExecutiveId;
    const userClientId = CurrentLoggedInUser?.UserClientId;

    const [client, setClient] = useState(tmpCache.client ?? []);
    const [selectedClient, setSelectedClient] = useState([]);

    const [site, setSite] = useState(tmpCache.site ?? []);
    const [selectedSite, setSelectedSite] = useState([]);


    const [reportedBy, setReportedBy] = useState(tmpCache.reportedBy ?? '');
    const [selectedReportedBy, setSelectedReportedBy] = useState([]);

    const [ownedBy, setOwnedBy] = useState(tmpCache.ownedBy ?? '');
    const [selectedOwnedBy, setSelectedOwnedBy] = useState([]);

    const [issueId, setIssueId] = useState(tmpCache.issueId ?? "");
    const [remark, setRemark] = useState(tmpCache.remark ?? "");
    const [issueRemark, setIssueRemark] = useState(tmpCache.issueRemark ?? "");


    const [effectiveFromValue, setEffectiveFromValue] = useState(tmpCache.effectiveFromValue ?? null);
    const [effectiveToValue, setEffectiveToValue] = useState(tmpCache.effectiveToValue ?? null);

    const [status, setStatus] = useState(tmpCache.status ?? 0);

    const [isCheck, setIsCheck] = useState(tmpCache.isCheck ?? false);

    // Edit issue modal

    const [childIssueData, setChildIssueData] = useState([]);
    const [pageSize1, setPageSize1] = useState(25);

    const [entryDate, setEntryDate] = useState("");

    const [editReportedBy, setEditReportedBy] = useState('');
    const [selectedEditReportedBy, setSelectedEditReportedBy] = useState([]);

    const [editClient, setEditClient] = useState([]);
    const [selectedEditClient, setSelectedEditClient] = useState([]);

    const [editSite, setEditSite] = useState([]);
    const [selectedEditSite, setSelectedEditSite] = useState([]);

    const [editIssueCategory, setEditIssueCategory] = useState('');
    const [selectedEditIssueCategory, setSelectedEditIssueCategory] = useState([]);

    const [editProject, setEditProject] = useState('');
    const [selectedEditProject, setSelectedEditProject] = useState([]);

    const [editMedium, setEditMedium] = useState('');
    const [selectedEditMedium, setSelectedEditMedium] = useState([]);

    const [editTicketNo, setEditTicketNo] = useState("");

    const [subStatus, setSubStatus] = useState("");
    const [selectedSubStatus, setSelectedSubStatus] = useState([]);

    const [editIsCheck, setEditIsCheck] = useState(false);
    const [editRemark, setEditRemark] = useState("");

    const [editAppointmentDate, setEditAppointmentDate] = useState("");
    const [editAppointmentTime, setEditAppointmentTime] = useState("");

    const [editDeliveryDate, setEditDeliveryDate] = useState("");
    const [editDeliveryTime, setEditDeliveryTime] = useState("");

    const [editIssueData, setEditIssueData] = useState("");

    const [editIssueId, setEditIssueId] = useState("");
    const [editChildIssueId, setEditChildIssueId] = useState("");

    const [childIssueId, setChildIssueId] = useState("");

    // Child issue modal
    const [editChildIssueData, setEditChildIssueData] = useState([]);
    const [treeViewData, setTreeViewData] = useState([]);

    const [editChildClient, setEditChildClient] = useState([]);
    const [selectedEditChildClient, setSelectedEditChildClient] = useState([]);

    const [editChildSite, setEditChildSite] = useState([]);
    const [selectedEditChildSite, setSelectedEditChildSite] = useState([]);

    const [editChildIssueCategory, setEditChildIssueCategory] = useState('');
    const [selectedEditChildIssueCategory, setSelectedEditChildIssueCategory] = useState([]);

    const [editChildOwnedBy, setEditChildOwnedBy] = useState('');
    const [selectedEditChildOwnedBy, setSelectedEditChildOwnedBy] = useState([]);

    const [editChildDeliveryDate, setEditChildDeliveryDate] = useState("");
    const [editChildDeliveryTime, setEditChildDeliveryTime] = useState("");

    const [editChildRemark, setEditChildRemark] = useState('');

    const [isLoading, setIsLoading] = useState();

    const [editIssueStatus, setEditIssueStatus] = useState(true);

    const [tabValue, setTabValue] = useState(0);

    const [openModal, setOpenModal] = useState(false);

    const [openChildModal, setOpenChildModal] = useState(false);

    const [treeViewModal, setTreeViewModal] = useState(false);

    const [estimated, setEstimated] = useState([]);

    const [requestFile, setRequestFile] = useState([]);

    const [isChildEditing, setIsChildEditing] = useState(false);
    const fileInputRef = useRef(null);
    const [selectedChild, setSelectedChid] = useState(null);

    const handleEstimatedChange = (id, value) => {
        setEstimated(prev =>
            prev.map(row =>
                row.Id === id ? { ...row, ExpectedTime: value } : row
            )
        );
    };

    const handleEstimatedTimeSave = (id) => {
        // Find the row in your issue data
        const row = issueData.find(r => r.Id === id);

        if (!row) return; // safety check

        const payload = {
            IssueId: row.Id,
            ExpectedTime: Number(row.ExpectedTime) || 0
        };

        URLS.updateExpectedTimeApi(payload)
            .then((response) => {
                enqueueSnackbar(response.data?.message, { variant: 'success' });

                console.log("Saved successfully:", response);
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.message || "Failed to save expected time!";
                enqueueSnackbar(errorMessage, { variant: "error" });
            });
        console.log("Saving row:", row.Id, row.ExpectedTime);
    };

    const clientRef = useRef(false);
    const siteRef = useRef(false);
    const reportedByRef = useRef(false);
    const ownedByRef = useRef(false);
    const issueIdRef = useRef(false);

    const fromDateRef = useRef(false);
    const toDateRef = useRef(false);
    const statusRef = useRef(false);

    const includeOtherRef = useRef(false);
    const remarkRef = useRef(false);
    const issueRemarkRef = useRef(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleFillService = (row) => {
        console.log("Clicked:", row.Id);
        const payload = {
            "ClientIdList": [0],
            "SiteIdList": [0],
            "ExecutiveID": 0,
            "ContactPersonId": 0,
            "frmDate": "",
            "toDate": "",
            "Status": 2,
            "IssueOwnedById": "",
            "Date": 0,
            "OrderBy": "",
            "IncludeChilren": 0,
            "PriorityId": 0,
            "SubStatusIdList": [0],
            "IssueCategoryIdList": [0],
            "IssueId": Number(row?.Id),
            "ProjectIdList": [0],
            "IssueCreatededById": 0
        };
        URLS.loadService(payload)
            .then((res) => {
                if (Array.isArray(res.data) && res.data.length > 0) {
                    const rowData = res.data[0];

                    navigate('/dashboard/servicedetailspage', { state: { loadData: rowData } });
                } else {
                    enqueueSnackbar("No service data found", { variant: "error" });
                }
            })
            .catch(() => {
                enqueueSnackbar("Failed to load service details", { variant: "error" });
            });
    };

    const TABLE_HEAD = [
        { field: 'Id', headerName: 'Issue ID', width: 80 },
        { field: 'Date', headerName: 'Date', width: 100, renderCell: (params) => Moment(params.value).format('DD-MMM-YYYY HH:mm:ss') },
        { field: 'ReportedBy', headerName: 'Reported By', width: 150 },
        { field: 'ClientName', headerName: 'Client', width: 200 },
        { field: 'Site', headerName: 'Site', width: 200 },
        { field: 'TicketNo', headerName: 'Ticket No.', width: 80 },
        { field: 'IssueOwnedBy', headerName: 'Owned By', width: 180 },
        {
            field: 'Remarks',
            headerName: 'Remark',
            width: 400,
            renderCell: (params) => {
                const formattedText = params.value || ""; // your remark content
                return (
                    <span
                        dangerouslySetInnerHTML={{ __html: formattedText }}
                    />
                );
            },
        },
        {
            field: 'ExpectedTime',
            headerName: 'Expected Time',
            width: 160, // increased a bit to fit both nicely
            sortable: false,
            renderCell: (params) => (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        width: '100%',
                        height: '100%',
                        border: 'none', // remove border inside cell
                        '&:hover': { border: 'none' }, // remove hover outline
                    }}
                >
                    <TextField
                        type="number"
                        size="small"
                        value={params.row.ExpectedTime || ""}
                        onChange={(e) => {
                            const value = e.target.value;
                            setIssueData((prev) =>
                                prev.map((row) =>
                                    row.Id === params.row.Id ? { ...row, ExpectedTime: value } : row
                                )
                            );
                        }}
                        variant="outlined"
                        sx={{
                            width: '52px',
                            height: '30px',
                            '& .MuiOutlinedInput-root': {
                                height: '30px',
                                fontSize: '12px',
                            },
                        }}
                    />
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleEstimatedTimeSave(params.row.Id)}
                        sx={{
                            width: '52px',
                            height: '26px',
                            backgroundColor: '#46BE50',
                            fontSize: '12px',
                            textTransform: 'none',
                        }}
                    >
                        Save
                    </Button>
                </Box>
            ),
        },
        {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            width: 80,
            headerAlign: 'right',
            align: 'right',
            renderCell: (cellValues) => {
                const canEdit = cellValues.row?.CreatedById === userId || cellValues.row?.ReportedById === userId; // ✅ check condition
                return (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",  // ✅ vertical alignment
                            width: "100%",
                            pr: 0.5,               // ✅ fine-tune horizontal spacing
                            boxShadow: 'none',

                        }}
                    >
                        {canEdit && (
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={(event) => handleClick(event, cellValues)}
                            >
                                <BorderColorOutlinedIcon sx={{ fontSize: 16, color: "#0867BD" }} />
                            </IconButton>
                        )}
                        <IconButton size="small" onClick={handleMenuOpen}>
                            <MoreVertIcon sx={{ fontSize: 18, color: "#444" }} />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={openMenu}
                            onClose={handleMenuClose}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            MenuListProps={{
                                sx: {
                                    width: 153,       // ✅ fixed menu width
                                    py: 0,            // remove extra top/bottom padding
                                    '& .MuiMenuItem-root': {
                                        height: 34,     // ✅ fixed height for each list item
                                        px: 1,        // optional: horizontal padding
                                        py: 0,          // ensure no vertical padding affects height
                                    },
                                    '& .MuiMenuItem-root .MuiListItemIcon-root': {
                                        minWidth: '0 !important', // ✅ force override
                                    },
                                    '& .MuiMenuItem-root:hover': {
                                        backgroundColor: "#FFF2F0",
                                    },
                                },
                            }}
                        >
                            <MenuItem
                                onClick={(event) => {
                                    event.preventDefault();
                                    handleFillService(cellValues.row);  // ✅ pass row with IssueId
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                    <Icon icon="material-symbols:list-alt-check-outline-rounded" width={16} height={16} color="#38383A" />
                                </ListItemIcon>
                                <ListItemText primary="Fill Service" />
                            </MenuItem>

                            <MenuItem onClick={(event) => {
                                event.preventDefault();
                                handleHierarchyClick(event, cellValues);
                            }}>
                                <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                    <AccountTreeOutlinedIcon sx={{ width: 16, height: 16, color: "#38383A" }} />
                                </ListItemIcon>
                                <ListItemText primary="Issue Hierarchy" />
                            </MenuItem>

                            <MenuItem
                                onClick={(event) => {
                                    event.preventDefault();
                                    handleChildClick(event, cellValues);
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 0, mr: 1 }} >
                                    <AddIcon sx={{ width: 16, height: 16, color: "#38383A" }} />
                                </ListItemIcon>
                                <ListItemText primary="Create Child Issue" />
                            </MenuItem>
                        </Menu>

                    </Box>
                );
            }
        }

    ];

    const CHILD_TABLE_HEAD = [
        { field: 'SrNo', headerName: 'Sr No', width: 60 },
        { field: 'Date', headerName: 'Date', width: 100, renderCell: (params) => Moment(params.value).format('DD-MMM-YYYY HH:mm:ss') },
        { field: 'ReportedBy', headerName: 'Reported By', width: 120 },
        { field: 'ClientName', headerName: 'Client', width: 200 },
        { field: 'Site', headerName: 'Site', width: 200 },
        { field: 'TicketNo', headerName: 'Ticket No.', width: 80 },
        { field: 'IssueOwnedBy', headerName: 'Issue Owned By', width: 180 },
        {
            field: 'Remarks',
            headerName: 'Remark',
            width: 400,
            renderCell: (params) => {
                const formattedText = params.value || ""; // your remark content
                return (
                    <span
                        dangerouslySetInnerHTML={{ __html: formattedText }}
                    />
                );
            },
        },
        {
            field: "actions",
            headerName: "Action",
            type: "actions",
            width: 100,
            headerAlign: "right", // Align header to the right
            align: "right", // Align content to the right
            renderCell: (cellValues) => (
                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#337ab7",
                            cursor: "pointer",
                            textDecoration: "underline",

                        }}
                        onClick={(event) => {
                            event.preventDefault();
                            handleChildClick(event, cellValues);
                        }}
                    >
                        Create Child Issue
                    </Typography>
                </div>
            ),
        }
    ];

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        handleReset();
        handleChildReset();
    };

    const handleClient = (newValue) => {
        setClient(newValue?.ClientId || "");
        clientRef.current = true;
    };
    const handleSite = (newValue) => {
        setSite(newValue?.SiteId || "");
        siteRef.current = true;

    };

    const handleReportedBy = (newValue) => {
        setReportedBy(newValue?.Id || "");
        reportedByRef.current = true;

    };
    const handleOwnedBy = (newValue) => {
        setOwnedBy(newValue?.Id || "");
        ownedByRef.current = true;

    };
    const handleIssueId = (e) => {
        setIssueId(e.target.value);
        issueIdRef.current = true;

    };
    const handleRemark = (e) => {
        setRemark(e.target.value);
        remarkRef.current = true;

    };
    const handleIssueRemark = (e) => {
        setIssueRemark(e.target.value);
        issueRemarkRef.current = true;

    };

    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue);
        if (!effectiveToValue) {
            setEffectiveToValue(newValue);
        }
        fromDateRef.current = true;

    };

    const handleEffTo = (newValue) => {
        setEffectiveToValue(newValue);
        toDateRef.current = true;

    };

    const handleStatus = (id) => {
        setStatus(id);
        statusRef.current = true;

    };
    const handleCheckbox = (event) => {
        setIsCheck(event.target.checked);
        includeOtherRef.current = true;

    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    // Edit issue modal onchange
    const handleEntryDate = (newValue) => {
        setEntryDate(newValue);
    };
    const handleEditReportedBy = (newValue) => {
        setEditReportedBy(newValue?.Id || "");

    };
    const handleEditClient = (newValue) => {
        setEditClient(newValue?.ClientId || "");
    };
    const handleEditSite = (newValue) => {
        setEditSite(newValue?.SiteId || "");

    };
    const handleEditCategory = (newValue) => {
        setEditIssueCategory(newValue?.Id || "");

    };
    const handleEditProject = (newValue) => {
        setEditProject(newValue?.ProjectVersionId || "");

    };
    const handleEditMedium = (id) => {
        setEditMedium(id);
    }
    const handleEditTicketNo = (event) => {
        setEditTicketNo(event.target.value);
    };
    const handleSubStatus = (newValue) => {
        setSubStatus(newValue?.Id || "");
    };
    const handleEditAppointmentDate = (newValue) => {
        setEditAppointmentDate(newValue);
    };
    const handleEditAppointmentTime = (event) => {
        setEditAppointmentTime(event.target.value);
    };
    const handleEditDeliveryDate = (newValue) => {
        setEditDeliveryDate(newValue);
    };

    const handleEditDeliveryTime = (event) => {
        setEditDeliveryTime(event.target.value);
    };

    // child edit popup
    const handleEditChildClient = (newValue) => {
        setEditChildClient(newValue?.ClientId || "");
    };
    const handleEditChildSite = (newValue) => {
        setEditChildSite(newValue?.SiteId || "");

    };
    const handleEditChildCategory = (newValue) => {
        setEditChildIssueCategory(newValue?.Id || "");

    };
    const handleEditChildOwnedBy = (newValue) => {
        setEditChildOwnedBy(newValue?.Id || "");

    };
    const handleEditChildAppointmentDate = (newDate) => {
        setEditChildDeliveryDate(newDate);

    };
    const handleEditChildAppointmentTime = (e) => {
        setEditChildDeliveryTime(e.target.value);

    };
    const handleEditChildRemark = (e) => {
        setEditChildRemark(e.target.value); // Time input uses "HH:mm"

    };
    const handleCloseChildModal = () => {
        setOpenChildModal(false);
        setIsChildEditing(false);
    };
    const handleTreeViewCloseModal = () => {
        setTreeViewModal(false);
        setIsChildEditing(false);

    };


    const handleSelectFile = (event) => {
        const selectedFiles = Array.from(event.target.files);

        console.log("selectedFiles", selectedFiles)
        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Data = reader.result; // Base64 string with data type prefix
                setRequestFile((prev) => [
                    ...prev,
                    {
                        file, // Original File object
                        name: file.name,
                        type: file.type,
                        base64: base64Data, // Base64 string
                    },
                ]);
            };
            reader.readAsDataURL(file); // Convert to base64
        });

        event.target.value = ""; // Clear the file input
    };
    console.log("selectedafile>>>>>>>>>>>>>>>>>>", requestFile)
    const removeFile = (index) => {
        setRequestFile((prevFiles) => prevFiles.filter((_, i) => i !== index)); // Remove file by index
    };
    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);
        setRequestFile((prev) => [...prev, ...droppedFiles]);
    };

    const handleDragOver = (event) => {
        event.preventDefault(); // allows drop
    };

    const handleDrgaDropClick = () => {
        fileInputRef.current.click();
    };
    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {
                setSelectedClient(Array.isArray(response.data) ? response.data : []);
                setSelectedEditClient(Array.isArray(response.data) ? response.data : []);
                setSelectedEditChildClient(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getServiceEntrySiteName({ ClientId: "0" })
            .then((response) => {
                setSelectedSite(Array.isArray(response.data) ? response.data : []);
                setSelectedEditSite(Array.isArray(response.data) ? response.data : []);
                setSelectedEditChildSite(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadExecutives(userClientId)
            .then((response) => {
                setSelectedReportedBy(response.data);
                setSelectedOwnedBy(response.data);
                setSelectedEditReportedBy(response.data);
                setSelectedEditChildOwnedBy(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadIssueCategory()
            .then((response) => {
                setSelectedEditIssueCategory(response.data);
                setSelectedEditChildIssueCategory(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getServiceEntryProject()
            .then((response) => {
                setSelectedEditProject(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getReportingMediumdata()
            .then((response) => {
                setSelectedEditMedium(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadStatusDropDown()
            .then((response) => {
                setSelectedSubStatus(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
    }, []);

    const handleClick = (event, cellValues) => {
        setIsLoading(true);
        setEditIssueId(cellValues.row.Id);

        URLS.editLoadIssue({ IssueId: cellValues.row.Id })
            .then((response) => {
                const modifiedData = response.data?.Issue?.[0];
                console.log("modifiedData", modifiedData);
                setEditIssueData(modifiedData);

                if (modifiedData) {
                    // set states directly here
                    setEntryDate(modifiedData.Date || "");
                    setEditReportedBy(modifiedData.ReportedById || "");
                    setEditClient(modifiedData.ClientId || "");
                    setEditSite(modifiedData.SiteId || "");
                    setEditIssueCategory(modifiedData.IssueCategory || "");
                    setEditProject(modifiedData.ProjectVersionId || "");
                    setEditMedium(modifiedData.ReportingMediumId || "");
                    setEditTicketNo(modifiedData.TicketNo || "");
                    setSubStatus(modifiedData.SubStatusId || "");
                    setEditIsCheck(modifiedData.ExcludeFromDashboard || "");
                    setEditRemark(modifiedData.Remarks || "");
                    setEditAppointmentDate(modifiedData.AppointmentDate || "");
                    setEditDeliveryDate(modifiedData.DeliveryDate || "");
                    setEditDeliveryTime(modifiedData.DeliveryTime || "");
                    setEditAppointmentTime(modifiedData.AppointmentTime || "");
                }

                setOpenModal(true);
            })
            .catch(() => enqueueSnackbar("Record not found", { variant: "error" }))
            .finally(() => setIsLoading(false));

        console.log("************************", cellValues);
    };

    const handleEditReset = () => {

        setEditDeliveryTime(new Date());
        setEntryDate(editIssueData.Date || "");
        setEditReportedBy(editIssueData.ReportedById || "");
        setEditClient(editIssueData.ClientId || "");
        setEditSite(editIssueData.SiteId || "");
        setEditIssueCategory(editIssueData.IssueCategory || "");
        setEditProject(editIssueData.ProjectVersionId || "");
        setEditMedium(editIssueData.ReportingMediumId || "");
        setEditTicketNo(editIssueData.TicketNo || "");
        setSubStatus(editIssueData.SubStatusId || "");
        setEditIsCheck(editIssueData.ExcludeFromDashboard || "");
        setEditRemark(editIssueData.Remarks || "");
        setEditAppointmentDate(editIssueData.AppointmentDate || "");
        setEditDeliveryDate(editIssueData.DeliveryDate || "");
        setEditDeliveryTime(editIssueData.DeliveryTime || "");
        setEditAppointmentTime(editIssueData.AppointmentTime || "");
        setEditIssueStatus(editIssueData.Status || "");
    };

    const onFilterClick = () => {
        setIsLoading(true);
        const payload = {
            ClientId: Array.isArray(client) && client.length === 0 ? 0 : (client || 0),
            SiteId: Array.isArray(site) && site.length === 0 ? 0 : (site || 0),
            ExecutiveID: 0,
            ContactPersonId: Array.isArray(reportedBy) && reportedBy.length === 0 ? 0 : (reportedBy || 0),
            Remark: remark || "",
            FromDate: effectiveFromValue ? Moment(effectiveFromValue).format('DD-MMM-YYYY') : '',
            ToDate: effectiveToValue ? Moment(effectiveToValue).format('DD-MMM-YYYY') : '',
            OwnedBy: Array.isArray(ownedBy) && ownedBy.length === 0 ? 0 : (ownedBy || 0),
            Status: status || 0,
            IssueRemark: issueRemark || "",
            IssueID: issueId || 0,
            IsAllInclude: isCheck === false ? 0 : 1,

        };


        console.log("filter payload", payload)
        URLS.loadIssueList(payload)
            .then((response) => {
                setIssueData(response.data);
                console.log("+++++++++++++++", response.data)
                setIsLoading(false);
                enqueueSnackbar("Fetched Data Successfully. ", { variant: 'success' });
            })
            .catch(error => {
                setIssueData([]);
                enqueueSnackbar("Data not found", { variant: 'success' });
                setIsLoading(false);

            });
    };

    const handleEditSave = () => {
        const payload = {
            "ClientId": editClient,
            "SiteId": editSite,
            "IssueId": editIssueId,
            "ReportingMediumId": editMedium || 0,
            "LoginId": userId,
            "IssueCreationDate": entryDate ? Moment(entryDate).format("DD-MMM-YYYY") : "",
            "IssueOwnedById": editIssueData?.IssueOwnedById || "",
            "ReportedById": editReportedBy,
            "IssueCategoryId": editIssueCategory || "",
            "PriorityId": editIssueData?.PriorityId,
            "SubStatusId": subStatus,
            "ProjectVersionId": editProject || 0,
            "AppointmentDatePart": editAppointmentDate ? Moment(editAppointmentDate).format("DD-MMM-YYYY") : "",
            "AppointmentTimePart": editAppointmentTime ? Moment(editAppointmentTime, ["HH:mm", "h:mm A", "HH:mm:ss"]).format("HH:mm") : "",
            "DeliveryDatePart": editDeliveryDate ? Moment(editDeliveryDate).format("DD-MMM-YYYY") : "",
            "DeliveryTimePart": editDeliveryTime ? Moment(editDeliveryTime, ["HH:mm", "h:mm A", "HH:mm:ss"]).format("HH:mm") : "",
            "Date": entryDate ? Moment(entryDate).format("DD-MMM-YYYY") : "",
            "CCEmailId": "",
            "DefultEmailId": "",
            "TicketNo": editTicketNo || "",
            "Remarks": editRemark || "",
            "Division": editIssueData?.Division || "",
            "RequestFrom": "",
            "LastRemarks": "",
            "IsCallListIssue": true,
            "ExcludeFromDashboard": editIsCheck,
            "ExpectedTime": editIssueData?.ExpectedTime,
            "ChildIssueId": 0,
            "FileName": "",
            "Status": editIssueStatus || "",
            "Files": requestFile.map((f) => ({
                FileBase64: f.base64,
                FileName: f.name,
            })),
            "IsChildIssueNew": false,
            "ParentIssueId": 0
        }
        console.log("edit payload>>>>>>>>>", payload)
        URLS.createNewIssue(payload)
            .then((response) => {
                console.log("create")
                if (response.status === 200) {
                    handleEditReset();
                    setOpenModal(false);
                    onFilterClick();
                }
                enqueueSnackbar(response.data.Message || "Record saved successfully.", { variant: 'success' });

            }).catch((error) => {
                const msg =
                    error.response?.data?.msg || "Record not saved.";
                enqueueSnackbar(msg, { variant: "error" });

            });
    };
    console.log("subStatus", subStatus)

    const onFilterChildClick = () => {
        setIsLoading(true);
        const payload = {
            ClientId: Array.isArray(client) && client.length === 0 ? 0 : (client || 0),
            SiteId: Array.isArray(site) && site.length === 0 ? 0 : (site || 0),
            ExecutiveId: 0,
            ReportedById: Array.isArray(reportedBy) && reportedBy.length === 0 ? 0 : (reportedBy || 0),
            FromDate: effectiveFromValue ? Moment(effectiveFromValue).format('DD-MMM-YYYY') : '',
            ToDate: effectiveToValue ? Moment(effectiveToValue).format('DD-MMM-YYYY') : '',
            OwnedById: Array.isArray(ownedBy) && ownedBy.length === 0 ? 0 : (ownedBy || 0),
            IssueId: issueId || 0,

        };


        console.log("filter payload", payload)
        URLS.childIssueListing(payload)
            .then((response) => {
                setChildIssueData(response.data);
                console.log("+++++++++++++++", response.data)
                setIsLoading(false);
                enqueueSnackbar("Fetched Data Successfully. ", { variant: 'success' });
            })
            .catch(error => {
                setChildIssueData([]);
                enqueueSnackbar("Data not found", { variant: 'success' });
                setIsLoading(false);

            });
    };

    const handleReset = () => {
        setClient([]);
        setSite([]);
        setReportedBy([]);
        setOwnedBy([]);
        setIssueId("");
        setEffectiveFromValue(null);
        setEffectiveToValue(null);
        setStatus(0);
        setIsCheck(false);
        setRemark("");
        setIssueRemark("");
        setIssueData([]);
    }

    const handleChildReset = () => {
        setClient([]);
        setSite([]);
        setReportedBy([]);
        setOwnedBy([]);
        setIssueId("");
        setEffectiveFromValue(null);
        setEffectiveToValue(null);
        setIssueData([]);
        setChildIssueData([]);
    }

    const handleChildClick = (event, cellValues) => {
        setIsLoading(true);

        URLS.childIssueDetailsListing({ IssueId: cellValues.row.Id })
            .then((response) => {
                const modifiedData = response.data;
                console.log("modifiedData", modifiedData);
                if (modifiedData?.ParentIssue && modifiedData.ParentIssue.length > 0) {
                    const parent = modifiedData?.ParentIssue?.[0] ?? {};
                    setEditChildIssueData(modifiedData);
                    setEditChildIssueId(cellValues.row.Id);

                    setEditChildClient(parent.ClientId || "");
                    setEditChildSite(parent.SiteId || "");
                    setEditChildIssueCategory(parent.IssueCategory || ""); // ⚠️ use Id not name
                    setEditChildOwnedBy(parent.IssueOwnedById || "");
                    setEditChildRemark(parent.Remarks || "");
                    setEditChildDeliveryDate(parent.Date1 || "");
                    setEditChildDeliveryTime(parent.Time ? Moment(parent.Time, "hh:mm A").format("HH:mm") : "");
                    setOpenChildModal(true);

                }
                else {
                    enqueueSnackbar(modifiedData?.Message || "Record not found", {
                        variant: "success",
                    });
                }
            })
            .catch(() => enqueueSnackbar("Record not found", { variant: "error" }))
            .finally(() => setIsLoading(false));
    };

    const handleHierarchyClick = (event, cellValues) => {
        setIsLoading(true);
        setEditIssueId(cellValues.row.Id);
        URLS.getIssueTreeView({ IssueId: cellValues.row.Id })
            .then((response) => {
                const data = response.data;

                if (data?.ParentIssue?.length > 0) {
                    setTreeViewData(data);
                    setEditChildIssueId(cellValues.row.Id);

                    // 👉 ONLY open tree view
                    setTreeViewModal(true);
                } else {
                    enqueueSnackbar(data?.Message || "Record not found", { variant: "success" });
                }
            })
            .catch(() => enqueueSnackbar("Record not found", { variant: "error" }))
            .finally(() => setIsLoading(false));
    };
    console.log("treeViewData", treeViewData)
    const handleEditChildIssue = (issue) => {
        setIsChildEditing(true);
        // Populate your form with the selected child issue values
        setChildIssueId(issue.Id);
        setEditChildClient(issue.ClientId || "");
        setEditChildSite(issue.SiteId || "");
        setEditChildIssueCategory(issue.IssueCategoryId || "");
        setEditChildOwnedBy(issue.IssueOwnedById || "");
        setEditChildRemark(issue.Remarks || "");
        setEditChildDeliveryDate(issue.Date || "");
        setEditChildDeliveryTime(issue.DeliveryTime ? Moment(issue.DeliveryTime, "hh:mm A").format("HH:mm") : "");

    };
    const handleEditChildReset = () => {
        if (!editChildIssueData) return;
        setIsChildEditing(false);

        const parent = editChildIssueData.ParentIssue?.[0] ?? {};

        setEditReportedBy(parent.ReportedById || "");
        setEditChildClient(parent.ClientId || "");
        setEditChildSite(parent.SiteId || "");
        setEditChildIssueCategory(parent.IssueCategory || "");
        setEditChildOwnedBy(parent.IssueOwnedById || "");
        setEditChildRemark("");
        setEditChildDeliveryDate(null);
        setEditChildDeliveryTime("");
        setRequestFile([]);
    };

    console.log("editChildIssueData", editChildIssueData);

    const handleEditChildSave = () => {
        if (!editChildRemark) {
            enqueueSnackbar("Remarks is required.");
            return false;
        }
        const parentPayload = {
            "ClientId": editChildClient,
            "SiteId": editChildSite,
            "IssueId": 0,
            "ReportingMediumId": editChildIssueData.ParentIssue?.[0].ReportingMediumId || 0,
            "LoginId": userId,
            "IssueCreationDate": editChildIssueData.ParentIssue?.[0].CreatedDate ? Moment(editChildIssueData.ParentIssue?.[0].CreatedDate).format("DD-MMM-YYYY") : "",
            "IssueOwnedById": editChildOwnedBy || "",
            "ReportedById": editChildIssueData.ParentIssue?.[0].ReportedById || "",
            "IssueCategoryId": editChildIssueCategory || "",
            "PriorityId": editChildIssueData.ParentIssue?.[0].PriorityId || "",
            "SubStatusId": editChildIssueData.ParentIssue?.[0].SubStatusId || "",
            "ProjectVersionId": editChildIssueData.ParentIssue?.[0].ProjectVersionId || "",
            "AppointmentDatePart": editChildIssueData.ParentIssue?.[0].AppointmentDate1 ? Moment(editChildIssueData.ParentIssue?.[0].AppointmentDate1).format("DD-MMM-YYYY") : "",
            "AppointmentTimePart": editChildIssueData.ParentIssue?.[0].AppointmentTime ? Moment(editChildIssueData.ParentIssue?.[0].AppointmentTime, ["HH:mm", "h:mm A", "HH:mm:ss"]).format("HH:mm") : "",
            "DeliveryDatePart": editChildDeliveryDate ? Moment(editChildDeliveryDate).format("DD-MMM-YYYY") : "",
            "DeliveryTimePart": editChildDeliveryTime ? Moment(editChildDeliveryTime, ["HH:mm", "h:mm A", "HH:mm:ss"]).format("HH:mm") : "",
            "Date": editChildIssueData.ParentIssue?.[0].Date ? Moment(editChildIssueData.ParentIssue?.[0].Date).format("DD-MMM-YYYY") : "",
            "CCEmailId": "",
            "DefultEmailId": "",
            "TicketNo": editChildIssueData.ParentIssue?.[0].TicketNo || "",
            "Remarks": editChildRemark || "",
            "Division": editChildIssueData.ParentIssue?.[0].Division || "",
            "RequestFrom": "",
            "LastRemarks": "",
            "IsCallListIssue": true,
            "ExcludeFromDashboard": editChildIssueData.ParentIssue?.[0].ExcludeFromDashboard,
            "ExpectedTime": editChildIssueData.ParentIssue?.[0].ExpectedTime,
            "ChildIssueId": 0,
            "FileName": "",
            "Status": editChildIssueData.ParentIssue?.[0].Status || "",
            "Files": requestFile.map((f) => ({
                FileBase64: f.base64,
                FileName: f.name,
            })),
            "IsChildIssueNew": true,
            "ParentIssueId": editChildIssueData.ParentIssue?.[0].Id || 0,
        }
        const childPayload = {
            "IssueId": childIssueId,
            "LoginId": userId,
            "ClientId": editChildClient,
            "SiteId": editChildSite,
            "IssueCategoryId": editChildIssueCategory,
            "IssueOwnedById": editChildOwnedBy,
            "DeliveryDate": editChildDeliveryDate ? Moment(editChildDeliveryDate).format("DD-MMM-YYYY") : "",
            "DeliveryTime": editChildDeliveryTime ? Moment(editChildDeliveryTime, "HH:mm").format("HH:mm") : "",
            "Remark": editChildRemark || ""
        }

        if (isChildEditing) {

            console.log("edit payload>>>>>>>>>", childPayload)
            URLS.saveChildIssue(childPayload)
                .then((response) => {
                    if (response?.status === 200) {
                        URLS.childIssueDetailsListing({ IssueId: editChildIssueId })
                            .then((response) => {
                                const modifiedData = response.data;

                                setEditChildIssueData(modifiedData);

                            })
                            .catch(() => console.log("error"))
                        handleEditChildReset();
                    }

                    enqueueSnackbar(response.data.Message || "Issue Updated Successfully.", { variant: 'success' });

                }).catch((error) => {
                    const msg =
                        error.response?.data?.msg || "Record not saved.";
                    enqueueSnackbar(msg, { variant: "error" });

                });

        } else {
            console.log("edit payload>>>>>>>>>", parentPayload)
            URLS.createNewIssue(parentPayload)
                .then((response) => {
                    console.log(">>> raw data", response);

                    if (response?.status === 200) {
                        URLS.childIssueDetailsListing({ IssueId: editChildIssueId })
                            .then((response) => {
                                const modifiedData = response.data;

                                const parent = modifiedData?.ParentIssue?.[0] ?? {};
                                setEditChildIssueData(modifiedData);

                            })
                            .catch(() => console.log("error"))
                        handleEditChildReset();
                    }

                    enqueueSnackbar(
                        response?.data?.Message || "Issue Saved Successfully.",
                        { variant: 'success' }
                    );
                })
                .catch((error) => {
                    const msg = error.response?.data?.Message || "Record not saved.";
                    enqueueSnackbar(msg, { variant: "error" });
                });

        }
    };

    const child = editChildIssueData.ChildIssues ?? {};
    const parent = editChildIssueData.ParentIssue?.[0] ?? {};
    console.log("isChildEditing", isChildEditing, editChildIssueId, child.length, child.length > 0, child)

    useEffect(() => {
        handleReset();
    }, [location.key]); 

    return (
        <>
            <Page title="Issue List" >

                <Box sx={{ display: 'flex', gap: 1, }}>
                    {!open && (
                        <Card sx={{ p: 0, height: '487px', width: '264px', display: 'flex', flexDirection: 'column', borderRadius: 0 }}>
                            <Box sx={{ p: 2, borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '48px' }}>
                                <Typography variant="h5" color="#000000">Filter</Typography>
                                <KeyboardDoubleArrowLeftIcon fontSize="small" sx={{ color: '#70747A', cursor: 'pointer' }} onClick={handleFilterCollapseClick} />

                            </Box>

                            <Box sx={{ flex: 1, overflowY: 'auto', px: 2, py: 1 }}>
                                <Stack spacing={2}>

                                    <FormControl size="small" fullWidth>
                                        <FormLabel >Issue ID</FormLabel>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            value={issueId}
                                            onChange={handleIssueId}
                                            type="number"
                                            placeholder="Select Option"

                                        />
                                    </FormControl>
                                    <FormControl fullWidth size="small">
                                        <FormLabel >Select Client</FormLabel>

                                        <Autocomplete

                                            fullWidth
                                            size="small"
                                            id="client"
                                            value={selectedClient.find((option) => option.ClientId === client) || ""}

                                            onChange={(_, newValue) => handleClient(newValue)}
                                            options={selectedClient}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}

                                            renderOption={(props, option) => (
                                                <li {...props} key={option.ClientId}>
                                                    {option.Name}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Client"
                                                    variant="outlined"
                                                />
                                            )}

                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth >
                                        <FormLabel >Select Site </FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="site"
                                            value={selectedSite.find((option) => option.SiteId === site) || ""}

                                            onChange={(_, newValue) => handleSite(newValue)}
                                            options={selectedSite}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.SiteId === value.SiteId}

                                            renderOption={(props, option) => (
                                                <li {...props} key={option.SiteId}>
                                                    {option.Name}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Site"
                                                    variant="outlined"
                                                />
                                            )}

                                        />
                                    </FormControl>

                                    <FormControl size="small" fullWidth >
                                        <FormLabel >Reported By </FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="reported"
                                            value={selectedReportedBy.find((option) => option.Id === reportedBy) || ""}
                                            onChange={(_, newValue) => handleReportedBy(newValue)}
                                            options={[{ Id: 0, Name: "Select" }, ...selectedReportedBy]}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}

                                            renderOption={(props, option) => (
                                                <li {...props} key={option.Id}>
                                                    {option.Name}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Reported By"
                                                    variant="outlined"
                                                />
                                            )}

                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth >
                                        <FormLabel >Owned By </FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="owned"
                                            value={selectedOwnedBy.find((option) => option.Id === ownedBy) || ""}
                                            onChange={(_, newValue) => handleOwnedBy(newValue)}
                                            options={[{ Id: 0, Name: "Select" }, ...selectedOwnedBy]}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}

                                            renderOption={(props, option) => (
                                                <li {...props} key={option.Id}>
                                                    {option.Name}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Owned By"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel >Remark</FormLabel>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            value={remark}
                                            onChange={handleRemark}
                                            placeholder="Remark"

                                        />
                                    </FormControl>


                                    <FormControl size="small" fullWidth>
                                        <FormLabel >From Date</FormLabel>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                inputFormat="dd/MMM/yyyy"
                                                value={effectiveFromValue}
                                                onChange={handleEffFrom}
                                                renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} />}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel >To Date</FormLabel>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker

                                                inputFormat="dd/MMM/yyyy"
                                                value={effectiveToValue}
                                                onChange={handleEffTo}
                                                renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} />}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel >Status</FormLabel>
                                        <Select
                                            size="small"
                                            value={status} // This binds the selected value to the state (status)
                                            onChange={(e) => handleStatus(e.target.value)} // Handle change for dropdown
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        backgroundColor: '#fbe9e7', // Set the background color here
                                                        maxHeight: '200px',
                                                        width: '200px', // Set the max height here

                                                    }
                                                }
                                            }}
                                        >
                                            {StatusDropdown.map((status) => (
                                                <MenuItem key={status.Id} value={status.Id}>
                                                    {status.value}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel >Issue Remark</FormLabel>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            value={issueRemark}
                                            onChange={handleIssueRemark}
                                            placeholder="Select Option"

                                        />
                                    </FormControl>
                                    <FormGroup>
                                        <FormControlLabel

                                            control={<Checkbox checked={isCheck} onChange={handleCheckbox} />}
                                            label="Include All Issues"
                                        />
                                    </FormGroup>
                                </Stack>
                            </Box>
                            <Box sx={{ p: 1, border: '1px solid #E5E5E5' }}>
                                <Stack direction="row" spacing={1} justifyContent="center">
                                    <Tooltip title="Reset">

                                        <Button variant="outlined" sx={{ width: '100px', color: '#374151' }} onClick={handleReset}>Reset</Button>
                                    </Tooltip >

                                    <Tooltip title="Filter">
                                        <Button variant="contained" sx={{ width: '100px' }} onClick={onFilterClick}>Apply</Button>
                                    </Tooltip >
                                </Stack>
                            </Box>
                        </Card>
                    )}

                    {open && (
                        <Card sx={{ p: 0, width: '35px', display: 'flex', flexDirection: 'column', borderRadius: 0, boxShadow: 'none', backgroundColor: '#F9FAFB' }}>

                            <IconButton
                                onClick={handleFilterClick}
                                sx={{
                                    position: "absolute",
                                    top: "18px",   // fixed top

                                    width: 20,
                                    height: 20,
                                    opacity: 1,
                                    p: 0,
                                    zIndex: 10,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '37px',
                                        height: '50px',
                                        backgroundColor: '#4682B4', // match your theme
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0,
                                        borderTopRightRadius: "10px",
                                        borderBottomRightRadius: "10px",
                                        border: 'none',
                                    }}
                                >
                                    <Icon icon="material-symbols:filter-arrow-right" width={24} height={24} color="#FFFFFF" />
                                </Box>
                            </IconButton>
                        </Card>
                    )}

                    <Box sx={{ flex: 1, mt: 1 }}>

                        <div style={{ height: '80vh', width: '100%' }}>
                            <DataGrid
                                rows={issueData}
                                columns={TABLE_HEAD}
                                density="compact"
                                getRowId={(row) => row.id || issueData.indexOf(row)}
                                getRowHeight={() => 'auto'}
                                components={{ Toolbar: GridToolbar }}
                                pagination
                                paginationMode="client"
                                rowsPerPageOptions={[25, 50, 100]}
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                sx={{
                                    borderRadius: 0,
                                    fontSize: "12px",
                                    color: "#717883",
                                    "& .MuiDataGrid-columnHeaders": {
                                        backgroundColor: "#FFF2F0",
                                        fontSize: "12px",
                                        color: "#374151",
                                        fontWeight: 600,
                                        border: "1px solid #E6E6E6",
                                    },
                                    "& .MuiDataGrid-cell": {
                                        fontSize: "12px",
                                        color: "#717883",
                                        py: "5px",

                                    },
                                }}
                            />
                        </div>

                        <Modal open={openModal} onClose={handleCloseModal}>
                            <Box sx={modalStyle}>
                                <Box
                                    sx={{
                                        position: 'sticky',
                                        top: 0,
                                        backgroundColor: '#fff',
                                        zIndex: 1,
                                        borderBottom: '1px solid #E5E5E5',


                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '5px 16px',
                                            borderBottom: '1px solid #E0E0E0',
                                            backgroundColor: '#fff',
                                            m: 0, // remove outer margins
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography variant="h5" color="text.primary" fontWeight="bold">
                                                Edit Issue - {editIssueId}
                                            </Typography>

                                            <Box
                                                sx={{
                                                    display: 'inline-flex',       // shrink/grow to fit text
                                                    height: '20px',
                                                    px: 1,                        // add some horizontal padding
                                                    borderRadius: '6px',
                                                    border: '1px solid #E5E5E5',
                                                    fontSize: '10px',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    background: '#fff',
                                                    whiteSpace: 'nowrap',         // prevent wrapping
                                                }}
                                            >
                                                {editIssueData?.SubStatusName}
                                            </Box>
                                        </Box>
                                        <IconButton onClick={handleCloseModal}  >
                                            <CloseIcon width={25} height={25} />
                                        </IconButton>
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        flex: 1,
                                        overflowY: 'auto',
                                        pt: 1,
                                        px: 2,
                                    }}
                                >
                                    <Stack spacing={1}>
                                        {/* Row 1 */}
                                        <Stack direction="row" spacing={3}>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel >Entry Date</FormLabel>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        inputFormat="dd/MMM/yyyy"
                                                        value={entryDate}
                                                        onChange={handleEntryDate}
                                                        renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} />}
                                                        disabled
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                            <FormControl size="small" fullWidth >
                                                <FormLabel >Reported By </FormLabel>
                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    id="reported"
                                                    value={selectedEditReportedBy.find((option) => option.Id === editReportedBy) || ""}
                                                    onChange={(_, newValue) => handleEditReportedBy(newValue)}
                                                    options={[{ Id: 0, Name: "Select" }, ...selectedEditReportedBy]}
                                                    getOptionLabel={(option) => option.Name || ""}
                                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder={
                                                                reportedBy.length === 0 ? "Select Option" : ""
                                                            }
                                                        />
                                                    )}

                                                />
                                            </FormControl>
                                        </Stack>
                                        <Stack direction="row" spacing={3}>
                                            <FormControl fullWidth size="small">
                                                <FormLabel > Client</FormLabel>

                                                <Autocomplete

                                                    fullWidth
                                                    limitTags={2}
                                                    size="small"
                                                    id="client"
                                                    value={selectedEditClient.find((option) => option.ClientId === editClient) || ""}

                                                    onChange={(_, newValue) => handleEditClient(newValue)}
                                                    options={selectedEditClient}
                                                    getOptionLabel={(option) => option.Name || ""}
                                                    isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder={
                                                                client.length === 0 ? "Select Option" : ""
                                                            }
                                                        />
                                                    )}


                                                />
                                            </FormControl>
                                            <FormControl size="small" fullWidth >
                                                <FormLabel > Site </FormLabel>
                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    id="site"
                                                    value={selectedEditSite.find((option) => option.SiteId === editSite) || ""}

                                                    onChange={(_, newValue) => handleEditSite(newValue)}
                                                    options={selectedEditSite}
                                                    getOptionLabel={(option) => option.Name || ""}
                                                    isOptionEqualToValue={(option, value) => option.SiteId === value.SiteId}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder={
                                                                site.length === 0 ? "Select Option" : ""
                                                            }
                                                        />
                                                    )}
                                                    limitTags={2}


                                                />
                                            </FormControl>
                                        </Stack>
                                        <Stack direction="row" spacing={3}>
                                            <FormControl size="small" fullWidth >
                                                <FormLabel >Category </FormLabel>
                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    id="category"
                                                    value={selectedEditIssueCategory.find((option) => option.Id === editIssueCategory) || ""}
                                                    onChange={(_, newValue) => handleEditCategory(newValue)}
                                                    options={[{ Id: 0, Name: "Select" }, ...selectedEditIssueCategory]}
                                                    getOptionLabel={(option) => option.Name || ""}
                                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder={
                                                                editIssueCategory.length === 0 ? "Select Option" : ""
                                                            }
                                                        />
                                                    )}

                                                />
                                            </FormControl>
                                            <FormControl size="small" fullWidth >
                                                <FormLabel >Project  </FormLabel>
                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    id="project"
                                                    value={selectedEditProject.find((option) => option.ProjectVersionId === editProject) || ""}
                                                    onChange={(_, newValue) => handleEditProject(newValue)}
                                                    options={[{ Id: 0, Name: "Select" }, ...selectedEditProject]}
                                                    getOptionLabel={(option) => option.ProjectVersionName || ""}
                                                    isOptionEqualToValue={(option, value) => option.ProjectVersionId === value.ProjectVersionId}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder={
                                                                editProject.length === 0 ? "Select Option" : ""
                                                            }
                                                        />
                                                    )}

                                                />
                                            </FormControl>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel >
                                                    Reporting Medium
                                                </FormLabel>
                                                <Select
                                                    size="small"
                                                    value={editMedium}
                                                    displayEmpty
                                                    renderValue={(selected) => {
                                                        if (!selected) {
                                                            return <span style={{ color: '#928A8A' }}>Select Medium</span>;
                                                        }
                                                        return selectedEditMedium.find((m) => m.Id === selected)?.Name;
                                                    }}

                                                    MenuProps={{
                                                        PaperProps: {
                                                            sx: {
                                                                backgroundColor: '#fbe9e7',
                                                                maxHeight: '200px',
                                                                width: '200px',
                                                            },
                                                        },
                                                    }}

                                                >
                                                    <MenuItem value="" onClick={() => handleEditMedium()} >Select Medium</MenuItem>

                                                    {selectedEditMedium.map((medium) => (
                                                        <MenuItem key={medium.Id} value={medium.Id} onClick={() => handleEditMedium(medium.Id)}>
                                                            {medium.Name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Stack>
                                        <Stack direction="row" spacing={3} alignItems="flex-end">
                                            {/* Second row of fields with fixed widths for alignment */}
                                            <FormControl size="small" sx={{ width: '275px' }}>
                                                <FormLabel>Ticket No.</FormLabel>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    value={editTicketNo}
                                                    onChange={handleEditTicketNo}
                                                    placeholder="Enter ticket number"
                                                />
                                            </FormControl>
                                            <FormControl size="small" sx={{ width: '278px' }}>
                                                <FormLabel>Issue Sub-Status</FormLabel>
                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    id="substatus"
                                                    value={selectedSubStatus.find((option) => option.Id === subStatus) || ""}
                                                    onChange={(_, newValue) => handleSubStatus(newValue)}
                                                    options={[{ Id: 0, Name: "Select" }, ...selectedSubStatus]}
                                                    getOptionLabel={(option) => option.Name || ""}
                                                    isOptionEqualToValue={(option, value) =>
                                                        option.Id === value.Id
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder={subStatus.length === 0 ? "Select Option" : ""}
                                                        />
                                                    )}

                                                />
                                            </FormControl>
                                            <Box sx={{ width: '275px' }}> {/* Adjusted Box width for alignment */}
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={editIsCheck}
                                                                onChange={(e) => setEditIsCheck(e.target.checked)}
                                                                icon={
                                                                    <Box
                                                                        sx={{
                                                                            width: 18,
                                                                            height: 18,
                                                                            border: '1px solid #D1D5DB',
                                                                            borderRadius: '4px',
                                                                        }}
                                                                    />
                                                                }
                                                                checkedIcon={
                                                                    <Box
                                                                        sx={{
                                                                            width: 18,
                                                                            height: 18,
                                                                            border: '1px solid #D1D5DB',
                                                                            borderRadius: '4px',
                                                                            backgroundColor: '#1976d2',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            color: '#fff',
                                                                            fontSize: 14,
                                                                        }}
                                                                    >
                                                                        ✓
                                                                    </Box>
                                                                }
                                                            />
                                                        }
                                                        label="Exclude from dashboard"
                                                    />
                                                </FormGroup>

                                            </Box>
                                        </Stack>
                                        <Stack direction="row" spacing={3}>
                                            <FormControl size="small" fullWidth>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <FormLabel>
                                                        Remark
                                                    </FormLabel>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ color: '#6F9DF9' }}
                                                    >
                                                        Last attempted by {editIssueData?.LastAttemptByName} on {Moment(editIssueData?.LastAttemptDate).format("DD-MMM-YYYY")}
                                                    </Typography>

                                                </Box>
                                                <TextareaAutosize
                                                    minRows={3}
                                                    placeholder="Remark"
                                                    style={{
                                                        width: "100%",
                                                        resize: "none",
                                                        fontFamily: "Inter",
                                                        border: "1px solid #E5E5E5",
                                                        borderRadius: "4px",
                                                        padding: "8px",
                                                    }}
                                                    value={stripHtml(editRemark)}
                                                    onChange={(e) => setEditRemark(e.target.value)}

                                                />
                                            </FormControl>
                                        </Stack>

                                        <Stack direction="row" spacing={3} alignItems="center">
                                            {/* Appointment Section */}
                                            <FormControl sx={{ flex: 1 }} size="small">
                                                <FormLabel>Appointment</FormLabel>
                                                <Stack direction="row" spacing={2} alignItems="center" mt={1}>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            inputFormat="dd/MMM/yyyy"
                                                            value={editAppointmentDate}
                                                            onChange={handleEditAppointmentDate}
                                                            renderInput={(params) => (
                                                                <TextField fullWidth size="small" {...params} error={false} />
                                                            )}
                                                            disabled
                                                        />
                                                    </LocalizationProvider>
                                                    <TextField
                                                        value={editAppointmentTime}
                                                        onChange={handleEditAppointmentTime}
                                                        type="text"
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ maxLength: 5 }}
                                                        size="small"
                                                        fullWidth
                                                        disabled
                                                    />

                                                </Stack>
                                            </FormControl>

                                            {/* Delivery Section */}
                                            <FormControl sx={{ flex: 1 }} size="small">
                                                <FormLabel>Delivery</FormLabel>
                                                <Stack direction="row" spacing={2} alignItems="center" mt={1}>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            inputFormat="dd/MMM/yyyy"
                                                            value={editDeliveryDate}
                                                            onChange={handleEditDeliveryDate}
                                                            renderInput={(params) => (
                                                                <TextField fullWidth size="small" {...params} error={false} />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                    <TextField
                                                        value={editDeliveryTime}
                                                        onChange={handleEditDeliveryTime}
                                                        type="text"
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ maxLength: 5 }}
                                                        size="small"
                                                        fullWidth
                                                        disabled
                                                    />

                                                </Stack>
                                            </FormControl>
                                        </Stack>
                                    </Stack>
                                </Box>
                                {/* Reset & Save Buttons */}
                                <Box
                                    sx={{
                                        position: 'sticky',
                                        bottom: 0,
                                        backgroundColor: '#fff',
                                        // mt: 2,
                                        p: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end', // keeps everything aligned right
                                        gap: 3,
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        color="#374151"
                                        sx={{ fontWeight: 600, fontSize: '14px' }}
                                    >
                                        Last updated:{" "}
                                        {editIssueData?.LastAttemptDate
                                            ? Moment(editIssueData.LastAttemptDate).format("DD-MMM-YYYY")
                                            : ""}{" "},{editIssueData?.LastAttemptTime || ""}
                                    </Typography>

                                    <Button variant="outlined" color="inherit" sx={{ width: "194px", height: "40px" }} onClick={handleEditReset}>
                                        Reset
                                    </Button>
                                    <Button
                                        size="medium"
                                        type="submit"
                                        variant="contained"
                                        onClick={handleEditSave}
                                        sx={{ width: "194px", height: "40px" }}
                                    >
                                        Save
                                    </Button>
                                </Box>

                            </Box>
                        </Modal>
                        <Modal open={openChildModal} onClose={handleCloseChildModal}>
                            <Box sx={childModalStyle}>
                                <Box
                                    sx={{
                                        position: 'sticky',
                                        top: 0,
                                        backgroundColor: '#fff',
                                        zIndex: 1,
                                        borderBottom: '1px solid #E5E5E5',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '5px 16px',
                                            m: 0, // remove outer margins
                                        }}
                                    >
                                        <Typography variant="h5" color="text.primary" fontWeight="bold">
                                            Issue Details
                                        </Typography>

                                        <IconButton onClick={handleCloseChildModal}>
                                            <CloseIcon width={25} height={25} />
                                        </IconButton>
                                    </Box>
                                </Box>

                                <Box
                                    sx={{
                                        flex: 1,
                                        overflowY: 'hidden',
                                        pt: 1,
                                        px: 2,
                                    }}
                                >
                                    <Stack spacing={1}>
                                        {/* Row 1 */}
                                        <Stack direction="row" spacing={2}>
                                            <FormControl fullWidth size="small">

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        borderRadius: "8px",
                                                        backgroundColor: "#FFF2F0",

                                                        px: 2,
                                                        py: 1,
                                                    }}
                                                >
                                                    <Typography variant="body2" sx={{ fontWeight: 400 }}>
                                                        Issue reported by <strong>{parent.ReportedBy}</strong> on the date{" "}
                                                        <strong>{parent.Date ? Moment(parent.Date).format("DD MMMM YYYY") : ""}</strong> of{" "}
                                                        <strong>{parent.ClientName} ({parent.Site})</strong> for{" "}
                                                        <strong>{parent.IssueCategory_LastRemark}</strong> and owned by{" "}
                                                        <strong>{parent.IssueOwnedBy}</strong>
                                                        <br />
                                                        <br />
                                                        <strong>‘{stripHtml(parent.Remarks)}’</strong>

                                                    </Typography>

                                                </Box>

                                            </FormControl>

                                        </Stack>
                                        <Box sx={{ display: "flex", gap: 2 }}>
                                            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
                                                <Stack direction="row" spacing={3}>
                                                    <FormControl fullWidth size="small">
                                                        <FormLabel > Client</FormLabel>

                                                        <Autocomplete

                                                            fullWidth
                                                            limitTags={2}
                                                            size="small"
                                                            id="client"
                                                            value={selectedEditChildClient.find((option) => option.ClientId === editChildClient) || ""}
                                                            onChange={(_, newValue) => handleEditChildClient(newValue)}
                                                            options={selectedEditChildClient}
                                                            getOptionLabel={(option) => option.Name || ""}
                                                            isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder={
                                                                        client.length === 0 ? "Select Option" : ""
                                                                    }
                                                                />
                                                            )}

                                                            disabled={isChildEditing}
                                                        />
                                                    </FormControl>
                                                    <FormControl size="small" fullWidth >
                                                        <FormLabel > Site </FormLabel>
                                                        <Autocomplete
                                                            fullWidth
                                                            size="small"
                                                            id="site"
                                                            value={selectedEditChildSite.find((option) => option.SiteId === editChildSite) || ""}

                                                            onChange={(_, newValue) => handleEditChildSite(newValue)}
                                                            options={selectedEditChildSite}
                                                            getOptionLabel={(option) => option.Name || ""}
                                                            isOptionEqualToValue={(option, value) => option.SiteId === value.SiteId}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder={
                                                                        site.length === 0 ? "Select Option" : ""
                                                                    }
                                                                />
                                                            )}
                                                            limitTags={2}
                                                            disabled={isChildEditing}

                                                        />
                                                    </FormControl>
                                                </Stack>
                                                <Stack direction="row" spacing={3}>
                                                    <FormControl size="small" fullWidth >
                                                        <FormLabel >Issue Category </FormLabel>
                                                        <Autocomplete
                                                            fullWidth
                                                            size="small"
                                                            id="category"
                                                            value={selectedEditChildIssueCategory.find((option) => option.Id === editChildIssueCategory) || ""}
                                                            onChange={(_, newValue) => handleEditChildCategory(newValue)}
                                                            options={[{ Id: 0, Name: "Select" }, ...selectedEditChildIssueCategory]}
                                                            getOptionLabel={(option) => option.Name || ""}
                                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder={
                                                                        editIssueCategory.length === 0 ? "Select Option" : ""
                                                                    }
                                                                />
                                                            )}

                                                        />
                                                    </FormControl>
                                                    <FormControl size="small" fullWidth >
                                                        <FormLabel >Issue Owned By</FormLabel>
                                                        <Autocomplete
                                                            fullWidth
                                                            size="small"
                                                            id="project"
                                                            value={selectedEditChildOwnedBy.find((option) => option.Id === editChildOwnedBy) || ""}
                                                            onChange={(_, newValue) => handleEditChildOwnedBy(newValue)}
                                                            options={[{ Id: 0, Name: "Select" }, ...selectedEditChildOwnedBy]}
                                                            getOptionLabel={(option) => option.Name || ""}
                                                            isOptionEqualToValue={(option, value) => option.Id === value.ProjectId}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder={
                                                                        editProject.length === 0 ? "Select Option" : ""
                                                                    }
                                                                />
                                                            )}

                                                            disabled={isChildEditing}
                                                        />
                                                    </FormControl>
                                                </Stack>
                                                <Stack direction="row" spacing={1}>
                                                    {/* Delivery Section */}
                                                    <FormControl size="small" sx={{ width: 415 }}>
                                                        <FormLabel>Delivery</FormLabel>
                                                        <Stack direction="row" alignItems="center" spacing={1}>
                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                <DesktopDatePicker
                                                                    inputFormat="dd/MMM/yyyy"
                                                                    value={editChildDeliveryDate}
                                                                    onChange={handleEditChildAppointmentDate}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            size="small"
                                                                            error={false}
                                                                            sx={{ flexBasis: "33%" }}   // 70% width
                                                                        />
                                                                    )}
                                                                    disabled={isChildEditing}
                                                                />
                                                            </LocalizationProvider>

                                                            <TextField
                                                                value={editChildDeliveryTime}
                                                                onChange={handleEditChildAppointmentTime}
                                                                type="time"
                                                                InputLabelProps={{ shrink: true }}
                                                                inputProps={{ step: 300 }}
                                                                size="small"
                                                                sx={{
                                                                    flexBasis: "21%",
                                                                    '& input::-webkit-calendar-picker-indicator': {
                                                                        display: 'none',   // hides the clock icon in Chrome/Safari/Edge
                                                                        WebkitAppearance: 'none',
                                                                    },
                                                                }}  // 30% width
                                                                disabled={isChildEditing}
                                                            />
                                                        </Stack>
                                                    </FormControl>

                                                </Stack>
                                                <Stack direction="row" spacing={2}>
                                                    <FormControl size="small" fullWidth>
                                                        <FormLabel>
                                                            Remark
                                                        </FormLabel>
                                                        <TextareaAutosize
                                                            minRows={3}
                                                            placeholder="Remark"
                                                            style={{
                                                                width: "100%",
                                                                resize: "none",
                                                                fontFamily: "Inter",
                                                                border: "1px solid #E5E5E5",
                                                                borderRadius: "4px",
                                                                padding: "8px",
                                                                height: "85px"
                                                            }}
                                                            value={stripHtml(editChildRemark)}
                                                            onChange={handleEditChildRemark}

                                                        />
                                                    </FormControl>

                                                </Stack>
                                            </Box>
                                            {/* Vertical Divider */}
                                            <Divider orientation="vertical" flexItem sx={{ backgroundColor: '#D1D5DB' }} />
                                            <Box sx={{ flex: 1 }}>
                                                <Stack direction="row" spacing={2}>

                                                    {requestFile.length === 0 ? (
                                                        <Box
                                                            component="label"
                                                            onDrop={handleDrop}
                                                            onDragOver={handleDragOver}
                                                            onClick={handleDrgaDropClick}
                                                            sx={{
                                                                border: '2px solid transparent',

                                                                // Use the borderImageSource with an SVG to create the custom dash pattern.
                                                                borderImageSource: 'url("data:image/svg+xml,%3csvg width=\'100%25\' height=\'100%25\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3crect width=\'100%25\' height=\'100%25\' fill=\'none\' rx=\'8\' ry=\'8\' stroke=\'%23ccc\' stroke-width=\'2\' stroke-dasharray=\'8%2c 8\'/%3e%3c/svg%3e")',
                                                                borderImageSlice: '1',
                                                                minHeight: "140px",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                color: "#757575",
                                                                cursor: "pointer",
                                                                width: '470px',
                                                                mb: 2,

                                                            }}
                                                            disabled={isChildEditing}

                                                        >
                                                            <Box
                                                                sx={{
                                                                    border: "1px solid #ddd",
                                                                    borderRadius: 2,
                                                                    backgroundColor: "#fff",
                                                                    p: 1.5,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    mb: 1,
                                                                    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                                                                    width: 57,
                                                                    height: 57,
                                                                }}
                                                            >
                                                                <Iconify
                                                                    icon="material-symbols:add-notes-outline-rounded"
                                                                    width={40}
                                                                    height={40}
                                                                    style={{ color: "#1a2b50" }}
                                                                />
                                                            </Box>
                                                            <Typography variant="body2">Drag & drop or click to choose files</Typography>

                                                            <input
                                                                type="file"
                                                                multiple
                                                                onChange={handleSelectFile}
                                                                style={{ display: "none" }}
                                                            />
                                                        </Box>
                                                    ) : (
                                                        /* After Upload: Second Image Style */
                                                        <Box sx={{ display: "flex", gap: 2 }}>
                                                            {/* Left Upload Area */}
                                                            <Box
                                                                component="label"
                                                                sx={{
                                                                    border: '2px solid transparent',

                                                                    // Use the borderImageSource with an SVG to create the custom dash pattern.
                                                                    borderImageSource: 'url("data:image/svg+xml,%3csvg width=\'100%25\' height=\'100%25\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3crect width=\'100%25\' height=\'100%25\' fill=\'none\' rx=\'8\' ry=\'8\' stroke=\'%23ccc\' stroke-width=\'2\' stroke-dasharray=\'8%2c 8\'/%3e%3c/svg%3e")',
                                                                    borderImageSlice: '1',
                                                                    minHeight: "140px",
                                                                    width: "230px", // Fixed width
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    color: "#757575",
                                                                    cursor: "pointer",
                                                                    flexShrink: 0,
                                                                    mb: 2,
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        border: "1px solid #ddd",
                                                                        borderRadius: 2,
                                                                        backgroundColor: "#fff",
                                                                        p: 1.5,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        mb: 1,
                                                                        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                                                                        width: 57,
                                                                        height: 57,
                                                                    }}
                                                                >
                                                                    <Iconify
                                                                        icon="material-symbols:add-notes-outline-rounded"
                                                                        width={40}
                                                                        height={40}
                                                                        style={{ color: "#1a2b50" }}
                                                                    />
                                                                </Box>
                                                                <Typography variant="body2">Drag & drop or click to choose files</Typography>
                                                                <input
                                                                    type="file"
                                                                    multiple
                                                                    onChange={handleSelectFile}
                                                                    style={{ display: "none" }}
                                                                />
                                                            </Box>

                                                            {/* Right File List */}
                                                            <Stack
                                                                spacing={1}
                                                                sx={{
                                                                    width: "220px", // Fixed width
                                                                    maxHeight: "140px",
                                                                    overflowY: "auto",
                                                                }}
                                                            >
                                                                {requestFile.map((file, index) => (
                                                                    <Box
                                                                        key={index}
                                                                        sx={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "space-between",
                                                                            border: "1px solid #ddd",
                                                                            borderRadius: 1,
                                                                            px: 1.5,
                                                                            py: 0.5,
                                                                            backgroundColor: "#f5f5f5",

                                                                        }}
                                                                    >
                                                                        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, overflow: "hidden", gap: 0.5 }}>
                                                                            <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>

                                                                                <Icon icon="tabler:file-text" width={18} height={18} style={{ color: "#616161" }} />
                                                                            </Box>
                                                                            <Typography
                                                                                variant="body2"
                                                                                noWrap
                                                                                title={file.name}
                                                                            >
                                                                                {file.name}
                                                                            </Typography>
                                                                        </Box>
                                                                        <IconButton
                                                                            edge="end"
                                                                            size="small"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                removeFile(index);
                                                                            }}
                                                                            sx={{
                                                                                color: '#FF1744',
                                                                                '&:hover': {
                                                                                    backgroundColor: 'rgba(255,23,68,0.1)',
                                                                                },
                                                                            }}
                                                                        >
                                                                            <Icon icon="material-symbols:delete-outline" width={17} height={17} />


                                                                        </IconButton>
                                                                    </Box>
                                                                ))}
                                                            </Stack>
                                                        </Box>

                                                    )}

                                                </Stack>
                                                {child.length > 0 && (
                                                    <Card sx={{
                                                        p: 1, backgroundColor: '#F3F3F5', mb: 2, overflowY: 'auto',      // vertical scroll
                                                        overflowX: 'hidden', maxHeight: 150,
                                                    }}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, overflow: 'auto' }}>
                                                            {editChildIssueData?.ChildIssues?.map((issue) => (
                                                                <Card
                                                                    key={issue.Id}
                                                                    sx={{ borderRadius: 2, boxShadow: 'none', border: '1px solid #ddd', height: '119px' }}
                                                                >
                                                                    <Box
                                                                        display="flex"
                                                                        justifyContent="space-between"
                                                                        alignItems="flex-start"
                                                                        px={1}
                                                                        pt={1}
                                                                        gap={1}
                                                                    >
                                                                        {/* Left Side */}
                                                                        <Box
                                                                            display="flex"
                                                                            flexWrap="wrap"
                                                                            alignItems="center"
                                                                            gap={2}
                                                                            sx={{ flex: 1, minWidth: 0 }}
                                                                        >
                                                                            {/* Displaying the Issue ID */}
                                                                            <Typography
                                                                                variant="subtitle2"
                                                                                sx={{
                                                                                    color: '#FC3838',
                                                                                    fontWeight: 700,
                                                                                    whiteSpace: 'nowrap',
                                                                                }}
                                                                            >
                                                                                {issue.Id}
                                                                            </Typography>

                                                                            {/* Displaying the remarks */}
                                                                            <Typography
                                                                                variant="subtitle1"
                                                                                fontWeight={600}
                                                                                sx={{
                                                                                    wordBreak: 'break-word',
                                                                                    whiteSpace: 'normal',
                                                                                }}
                                                                            >
                                                                                For : {issue.IssueCategory}
                                                                            </Typography>

                                                                            {/* Displaying a status chip based on the Status field */}
                                                                            <Chip
                                                                                label={issue.Status ? "Completed" : "Pending"}
                                                                                size="small"
                                                                                sx={{
                                                                                    width: '80px',
                                                                                    height: '20px',
                                                                                    borderRadius: '6px',
                                                                                    backgroundColor: issue.Status ? "#E3F2FD" : "#FEF9C2",
                                                                                    color: issue.Status ? "#1976D2" : "#894B00",
                                                                                    fontSize: '12px',
                                                                                }}
                                                                            />
                                                                        </Box>

                                                                        {/* Right Side */}

                                                                        <IconButton
                                                                            onClick={() => handleEditChildIssue(issue)}
                                                                            size="small"
                                                                        >
                                                                            <Iconify
                                                                                icon="material-symbols:edit-square-outline"
                                                                                width={20}
                                                                                height={20}
                                                                                style={{ color: '#0867BD' }}

                                                                            />
                                                                        </IconButton>
                                                                    </Box>

                                                                    <CardContent sx={{ p: 1, }}>

                                                                        <Grid container spacing={1} >
                                                                            <Grid container item xs={12} rowSpacing={0}>
                                                                                <Grid item xs={12}>
                                                                                    <Typography variant="body2" fontWeight={500}>
                                                                                        Client/Site:{' '}
                                                                                        <Typography component="span" color="text.secondary">
                                                                                            {issue.Client}: {issue.SiteName}
                                                                                        </Typography>
                                                                                    </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <Typography variant="body2" fontWeight={500}>
                                                                                        Assigned To:{' '}
                                                                                        <Typography component="span" color="text.secondary">
                                                                                            {issue.IssueOwnedBy}
                                                                                        </Typography>
                                                                                    </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <Typography variant="body2" fontWeight={500}>
                                                                                        Last Issue remark:{' '}
                                                                                        <Typography
                                                                                            component="span"
                                                                                            color="text.secondary"
                                                                                        >
                                                                                            {issue.Remarks}
                                                                                        </Typography>
                                                                                    </Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </CardContent>
                                                                </Card>
                                                            ))}
                                                        </Box>
                                                    </Card>
                                                )}

                                            </Box>
                                        </Box>
                                    </Stack>
                                </Box>
                                {/* Reset & Save Buttons */}
                                <Box
                                    sx={{
                                        position: 'sticky',
                                        bottom: 0,
                                        backgroundColor: '#fff',
                                        // mt: 2,
                                        p: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end', // keeps everything aligned right
                                        gap: 3,
                                        borderTop: '1px solid #D1D5DB',
                                    }}
                                >


                                    <Button variant="outlined" color="inherit" sx={{ width: 194, height: 40 }} onClick={handleEditChildReset}>
                                        Reset
                                    </Button>
                                    <Button
                                        size="medium"
                                        type="submit"
                                        variant="contained"
                                        onClick={handleEditChildSave}
                                        sx={{ width: 194, height: 40 }}
                                    >
                                        Save
                                    </Button>
                                </Box>

                            </Box>
                        </Modal>
                        <Modal open={treeViewModal} onClose={handleTreeViewCloseModal}>
                            <Box sx={hierarchyStyle}>
                                <Box
                                    sx={{
                                        position: 'sticky',
                                        top: 0,
                                        backgroundColor: '#fff',
                                        zIndex: 1,
                                        borderBottom: '1px solid #E5E5E5',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '5px 16px',
                                            m: 0, // remove outer margins
                                        }}
                                    >
                                        <Stack >
                                            <Typography variant="h5" color="text.primary" fontWeight="bold">
                                                Issue Hierarchy Overview
                                            </Typography>

                                            <Typography color="#837171" fontWeight="400">
                                                Parent issue {editIssueId} with all child dependencies
                                            </Typography>
                                        </Stack>

                                        <IconButton onClick={handleTreeViewCloseModal}>
                                            <CloseIcon width={25} height={25} />
                                        </IconButton>
                                    </Box>
                                </Box>

                                <Box
                                    sx={{
                                        flex: 1,
                                        overflowY: 'auto',
                                        py: 2,
                                        px: 2,
                                    }}
                                >
                                    <TreeView
                                        parent={treeViewData?.ParentIssue?.[0]}
                                        child={treeViewData?.ChildIssues}
                                        subChild={treeViewData?.SubChildIssues}
                                        onFillServiceClick={handleFillService}
                                    />

                                </Box>

                            </Box>
                        </Modal>
                    </Box>

                </Box>

                {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}

            </Page>

        </>

    );
}